<template>
  <div class="d-flex flex-nowrap">
    <v-icon v-for="i in parseInt(size)" dense color="secondary">mdi-star</v-icon>
  </div>
</template>
<script>
/**
 * display the difficulty of question by stars (view only)
 */
export default {
  name: 'difficulty',
  props: {
    size: undefined
  }
}
</script>
